import { returnDecimalFormatting } from "@/lib/globalFormatterHelper";
import { InstrumentTypeCode } from "@/lib/interfaces and Enums/ENUMInstrumentTypeCode";
import tradeBlockDataStore from "@/store/tradeBlockDataStore";
import { useTheme } from "next-themes";

export function showCouponField(unwind: "NPV" | "Recoupon" | null): boolean {
  if (unwind == "NPV" || unwind == "Recoupon") {
    return true;
  }
  return false;
}

// Coupon now it's stand alone file - Coupon currently using the multiplying logic in front end - All indicativeMid's now coming over via the api.
const CouponSwapCellRenderer = (params: any) => {
  const { theme } = useTheme();

  const currentTradeBlockData = tradeBlockDataStore(
    (state) => state.tradeBlockData,
  );
  const theseBlocks = currentTradeBlockData.find(
    (blocks) =>
      blocks.esid == params.colDef.cellRendererParams.fullTradeData.esid,
  );
  const thisBlock = theseBlocks?.blocks?.find(
    (block) => block.id == params.data.id,
  );

  if (!thisBlock) {
    return;
  }

  const getInputStyling = () => {
    let isEditable = false;
    const unwind = thisBlock?.unwind || null;
    if (unwind != null) {
      isEditable = true;
    } else isEditable = false;

    if (isEditable) {
      return theme == "light"
        ? "inputCellOtherLight roundedInputCell"
        : "inputCellOtherDark roundedInputCell";
    }
  };

  //14608 - Show notation of the block and miltiply the
  const notationToShow = thisBlock.notation || "";

  if (thisBlock.instrumentType == InstrumentTypeCode.SWP) {
    return (
      <div className={`${getInputStyling()}`}>
        {showCouponField(thisBlock.unwind) &&
          `${returnDecimalFormatting(Number(thisBlock.coupon), notationToShow)} ${notationToShow}`}
      </div>
    );
  } else {
    return;
  }
};

export default CouponSwapCellRenderer;
